/**
 * @generated SignedSource<<7d1529a2d084d56cf332f666ca4b1f75>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type routeOnboardingClubQuery$variables = {
  slug: string;
};
export type routeOnboardingClubQuery$data = {
  readonly club: {
    readonly id: string;
    readonly logo: {
      readonly signedUrl: string;
    } | null | undefined;
    readonly name: string;
    readonly slug: string;
    readonly themes: ReadonlyArray<{
      readonly originalTheme: {
        readonly name: string;
      };
      readonly styles: any;
    }> | null | undefined;
  };
};
export type routeOnboardingClubQuery = {
  response: routeOnboardingClubQuery$data;
  variables: routeOnboardingClubQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "slug"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "slug"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "signedUrl",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "styles",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "routeOnboardingClubQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Club",
        "kind": "LinkedField",
        "name": "club",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ImageFile",
            "kind": "LinkedField",
            "name": "logo",
            "plural": false,
            "selections": [
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ClubTheme",
            "kind": "LinkedField",
            "name": "themes",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "DefaultTheme",
                "kind": "LinkedField",
                "name": "originalTheme",
                "plural": false,
                "selections": [
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "routeOnboardingClubQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Club",
        "kind": "LinkedField",
        "name": "club",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ImageFile",
            "kind": "LinkedField",
            "name": "logo",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ClubTheme",
            "kind": "LinkedField",
            "name": "themes",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "DefaultTheme",
                "kind": "LinkedField",
                "name": "originalTheme",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2ed7b3a248902ef5f1f55303386a3d68",
    "id": null,
    "metadata": {},
    "name": "routeOnboardingClubQuery",
    "operationKind": "query",
    "text": "query routeOnboardingClubQuery(\n  $slug: String!\n) {\n  club(slug: $slug) {\n    id\n    name\n    slug\n    logo {\n      signedUrl\n      id\n    }\n    themes {\n      originalTheme {\n        name\n        id\n      }\n      styles\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ce4524208821fea0f2aa7361a05257c9";

export default node;
